// COMPONENTS
import { type ChangeEvent, useState } from 'react';
import { useSelector } from 'react-redux';
// i18N
import { getText } from 'i18n/intl';
import { useAppDispatch } from 'slices/store';
// REDUX
import {
  fetchSystemActionInfo,
  systemInfoSelector,
} from 'slices/systemActions.slice';
import type { TSystemAction } from '@timeedit/types/lib/types/systemAction.type';
import { Button } from '@timeedit/ui-components';
import { Input, Select } from '@timeedit/ui-components/antd';
// STYLES
import './component.scss';

type PropsSystemActions = {
  systemActions: TSystemAction[];
};

export const MaintenanceMiscellaneous = ({
  systemActions,
}: PropsSystemActions) => {
  const dispatch = useAppDispatch();
  const systemInfo = useSelector(systemInfoSelector);
  const [action, setAction] = useState<string | null>();
  const [choosenValue, setChoosenValue] = useState<string | number | null>();
  const [noValueSelected, setNoValueSelected] = useState<string | null>();

  const getActionInfo = (actionSelect: string) => {
    const selectedSystemAction = systemActions.find(
      (systemAction: TSystemAction) => systemAction.id === actionSelect
    );

    if (selectedSystemAction && selectedSystemAction.requiresValue === false) {
      dispatch(fetchSystemActionInfo(selectedSystemAction.id));
    } else if (
      selectedSystemAction &&
      selectedSystemAction.requiresValue === true &&
      choosenValue === undefined
    ) {
      setNoValueSelected('Please select a value');
    } else if (
      selectedSystemAction &&
      selectedSystemAction.requiresValue === true &&
      choosenValue !== undefined
    ) {
      setNoValueSelected(null);
      dispatch(fetchSystemActionInfo(selectedSystemAction.id, choosenValue));
    }
  };

  return (
    <div style={{ padding: '0px 15px' }}>
      <div className="action-top-bar--wrapper">
        <div>
          <p className="form-item-text" style={{ margin: 0 }}>
            {getText('select_action')}
          </p>
          <Select
            size="small"
            onChange={(value: string) => {
              setAction(value);
              setChoosenValue(undefined);
              setNoValueSelected(null);
              getActionInfo(value);
            }}
            style={{ width: 200 }}
          >
            {systemActions?.map((actionType) => (
              <Select.Option key={actionType.id} value={actionType.id}>
                {actionType.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div style={{ margin: '0px 20px' }}>
          <p className="form-item-text" style={{ margin: 0 }}>
            {getText('value')}
          </p>
          <Input
            size="small"
            value={choosenValue}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setChoosenValue(event.target.value)
            }
            style={{ width: 200 }}
          />
        </div>
        <Button
          size="small"
          style={{ marginLeft: 5, marginBottom: 2 }}
          onClick={() => getActionInfo(action)}
        >
          {getText('search')}
        </Button>
      </div>
      {noValueSelected !== null && (
        <p
          style={{
            color: '#ff6357',
            fontSize: '16px',
          }}
        >
          {noValueSelected}
        </p>
      )}
      <div className="system-actions-box">
        <pre>
          <code>{systemInfo}</code>
        </pre>
      </div>
    </div>
  );
};
